export default {
  "content": "<path d=\"M6 0a6 6 0 100 12A6 6 0 006 0zm2.95 4.743L6.033 8.221a.75.75 0 01-.542.268H5.46a.75.75 0 01-.53-.22l-1.5-1.5a.75.75 0 111.06-1.06l.92.921L7.8 3.78a.75.75 0 111.15.964v-.001z\" fill=\"currentColor\"/>",
  "attrs": {
    "width": "12",
    "height": "12",
    "viewBox": "0 0 12 12",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};